/* eslint-disable */
var uloc = {}

// exposed global options
uloc.config = {}

uloc.install = function (Vue) {

  Vue.prototype.$uloc = uloc

}

export default uloc


// WEBPACK FOOTER //
// ./src/uloc.js